import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const TypeNPS = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path d="M12.9999 2.05005V5.08005C16.3899 5.57005 18.9999 8.47005 18.9999 12C18.9999 12.9 18.8199 13.75 18.4999 14.54L21.1199 16.07C21.6799 14.83 21.9999 13.45 21.9999 12C21.9999 6.82005 18.0499 2.55005 12.9999 2.05005ZM11.9999 19C10.1434 19 8.36294 18.2626 7.05018 16.9498C5.73743 15.637 4.99993 13.8566 4.99993 12C4.99993 8.47005 7.60993 5.57005 10.9999 5.08005V2.05005C5.93993 2.55005 1.99993 6.81005 1.99993 12C1.99993 14.6522 3.0535 17.1958 4.92886 19.0711C5.85745 19.9997 6.95984 20.7363 8.1731 21.2388C9.38635 21.7414 10.6867 22 11.9999 22C15.2999 22 18.2299 20.39 20.0499 17.91L17.4499 16.38C16.1699 18 14.2099 19 11.9999 19Z" />
    <path d="M8.77425 13.8875C9.32653 14.8441 10.5497 15.1718 11.5063 14.6196C12.4629 14.0673 16.5685 9.3875 16.5685 9.3875C16.5685 9.3875 10.4629 10.6032 9.5063 11.1554C8.54971 11.7077 8.22196 12.9309 8.77425 13.8875Z" />
  </SvgIcon>
));

TypeNPS.displayName = 'TypeNPS';

export default TypeNPS;
